import api from "@/services/api/api-courseLeaders";
import {CourseLeader} from "@/app/admin/modules/course_leaders/core/models/courseLeaderModel";

export default class CourseLeadersService {
  
  constructor() {
    if (CourseLeadersService.instance) {
      return CourseLeadersService.instance;
    }

    this.loading = false;
    
    CourseLeadersService.instance = this;
    return this;
  }

  async listCached(query) {
    if( this.loading && this.cachedPromise ) {
      return this.cachedPromise;
    } else if( this.cachedItems ) {
      return this.cachedItems;
    }
    this.loading = true;
    this.cachedPromise = this.list(query);
    this.cachedItems = await this.cachedPromise;
    this.loading = false;
    return this.cachedItems;
  }
  
  clearCache() {
    delete this.cachedItems;
  }
  
  async list(query) {
    try {
      let res = await api.list(query);
      if(!res) throw new Error('Something wrong and account not loaded. Please, reload page or try later.')
      let data = {
        results: res.map( item => new CourseLeader(item)),
      }
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async create(data) {
    try {
      let res = await api.create(data)
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async update(data) {
    try {
      let res = await api.update(data)
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }

}
